/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coinvestments_Performancereport_Updated2Inputs */

const en_coinvestments_performancereport_updated2 = /** @type {(inputs: Coinvestments_Performancereport_Updated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Coinvestments_Performancereport_Updated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_updated2 = /** @type {((inputs: Coinvestments_Performancereport_Updated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Updated2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_updated2(inputs)
});
export { coinvestments_performancereport_updated2 as "coInvestments_performanceReport_updated" }